/**
 * Husleierett Module Description
 * Master Grade modul for husleierettslige prosesser
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const HUSLEIERETT_CONFIG = {
  id: 'husleierett',
  title: 'Husleierett',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen husleierett med lokal AI-drevet tekstanalyse, automatisk fristberegning og generering av strukturerte dokumentutkast. Modulen er utviklet for å gi et helhetlig arbeidsverktøy for både leietakere og utleiere.",
  
  aboutModule: "Husleierett-modulen gir verktøy for å analysere kontrakter, vurdere mangler, beregne prisavslag og håndtere sentrale prosesser som fremleie, depositum og erstatningskrav – i tråd med husleieloven og tilhørende praksis.",
  
  leietakerFeatures: [
    "AI-drevet kontraktanalyse med fokus på ulovlige eller ubalanserte vedlikeholdsklausuler",
    "Mangelsveiviser med prisavslagskalkulator basert på husleieloven § 2-11",
    "Fremleieassistent med automatisk generering av søknad",
    "Krav om utbetaling av depositum direkte til banken"
  ],
  
  utleierFeatures: [
    "Erstatningskalkulator med nytteverdi-fradrag ved skader og mangler",
    "Veiledning for lovlig gjennomføring av utkastelse etter tvangsfullbyrdelsesloven § 4-18",
    "Interaktiv vedlikeholdsmatrise for fordeling av ansvar"
  ],
  
  privacyText: "All behandling og lagring skjer lokalt på din enhet. Dokumenter og metadata lagres ikke på servere og deles ikke med RettVerk."
};

export function HusleierettDescription() {
  const config = HUSLEIERETT_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="🏠" title="For leietakere">
        <FeatureList features={config.leietakerFeatures} />
      </ModuleSection>
      
      <ModuleSection icon="🔑" title="For utleiere">
        <FeatureList features={config.utleierFeatures} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default HusleierettDescription;
